import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FeedbackFormModalComponent } from '@shared/feedback-form-modal/feedback-form-modal.component';
import { from, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {

  constructor(
    public modalService: NgbModal,
  ) {}

  openFeedbackForm(fromMaterialViewer: boolean = false) {
    const feedbackFormModalRef = FeedbackFormModalComponent.open(this.modalService, fromMaterialViewer);

    return from(feedbackFormModalRef.result).pipe(catchError(() => of(false)));
  }
}
